var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.members,"label":_vm.label,"item-text":"text","item-value":"value","clearable":"","outlined":"","background-color":_vm.backgroundColor,"dense":"","hide-details":_vm.hideDetails ? _vm.hideDetails : false},on:{"input":(event) => {
    _vm.$emit('input', event);
  }},model:{value:(_vm.selectedMember),callback:function ($$v) {_vm.selectedMember=$$v},expression:"selectedMember"}})
}
var staticRenderFns = []

export { render, staticRenderFns }